// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from '../Icon'
import { colors } from '@lmc/common/constants'
import { theme } from '@lmc/ui-kit'

export default function Checkbox({ isChecked, label, onChange, style }) {
  return (
    <div
      className="lmc-option-field"
      onClick={onChange}
      style={{ ...styles.container, ...style }}
    >
      <div style={styles.valueContainer}>
        <span style={styles.checkboxLabel}>{label}</span>
      </div>
      <Icon
        name={isChecked ? 'checkbox-on' : 'checkbox-off'}
        fill={isChecked ? theme.color.status.primary : null}
        size={24}
        style={styles.icon}
      />
    </div>
  )
}

const styles = {
  container: {
    borderColor: colors.darkgrey,
  },
  checkboxLabel: {
    alignSelf: 'center',
    display: 'block',
    marginRight: 5,
  },
  icon: {
    flexShrink: 0,
  },
  valueContainer: {
    alignItems: 'center',
    display: 'flex',
  },
}

Checkbox.propTypes = {
  isChecked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
}
